import { render, staticRenderFns } from "./ClosingSection.vue?vue&type=template&id=431b8946&"
import script from "./ClosingSection.vue?vue&type=script&lang=js&"
export * from "./ClosingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports